import { render, staticRenderFns } from "./ConsumerProfile.vue?vue&type=template&id=24303b97&scoped=true&"
import script from "./ConsumerProfile.vue?vue&type=script&lang=js&"
export * from "./ConsumerProfile.vue?vue&type=script&lang=js&"
import style0 from "./ConsumerProfile.vue?vue&type=style&index=0&id=24303b97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24303b97",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
